var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isLoading
        ? _c(
            "v-row",
            {
              staticClass: "fill-height",
              attrs: { "no-gutters": "", justify: "center", align: "center" }
            },
            [
              _c(
                "v-col",
                { attrs: { cols: "1" } },
                [
                  _c("v-progress-circular", {
                    class: _vm.progressClass,
                    attrs: {
                      indeterminate: "",
                      size: "50",
                      width: "5",
                      color: "light-blue"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm.isEmpty
        ? _c("div", { staticClass: "error text-center" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.generateMessage(`${_vm.i18nPath}.noItems`)) +
                "\n  "
            )
          ])
        : _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }